module.exports = __webpack_public_path__ + "static/lisapro-printer-57b8dc647e875b14c553b8be912e0b29.png";